// extracted by mini-css-extract-plugin
export default {"caffswitch":"Vv","lever":"Wv","toggle_rect":"Xv","toggle_rect_bundles":"Yv","switch":"Zv"};
    if(module.hot) {
      // 1713969936437
      var cssReload = require("../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  